// TODO: should be marked as server-only
// import 'server-only';
import { getTranslations } from 'next-intl/server';
import { DEFAULT_REVIEWS_LIMIT, DEFAULT_REVIEWS_OFFSET, Locale, ServerActionName } from '@headless-workspace/config';
import {
    ResultFailure,
    ResultServerAction,
    ResultServerActionType,
    ResultSuccess,
} from '@headless-workspace/core-domain';
import { CommonDI, LoggerType } from '@headless-workspace/domain/common/DI';
import { DI, ReviewsRepositoryType } from '../../../../DI';
import { RatingsAndReviewsValue } from '../ratingsAndReviews';
import { ReviewsError } from './serverActions/ReviewsError';
import { mapSortingOptions } from './serverActions/mapSortingOptions';

export const getReviewsWithSorting = async (
    locale: Locale,
    productId: string,
    offset = DEFAULT_REVIEWS_OFFSET,
    limit = DEFAULT_REVIEWS_LIMIT,
    filters: number[],
    sort?: string,
): Promise<ResultServerActionType<RatingsAndReviewsValue>> => {
    const t = await getTranslations('Discover.Pdp.ratingAndReviews.error');

    const ratingFilter = filters.length > 0 ? `rating:(${filters.join(';')})` : undefined;

    const reviewsResult = await DI.get(ReviewsRepositoryType).getReviews(
        locale,
        productId,
        offset,
        limit,
        ratingFilter,
        sort,
    );

    if (reviewsResult.type !== 'success') {
        CommonDI.get(LoggerType).info(ReviewsError.Default, t(ReviewsError.Default));
        const result = ResultFailure(ReviewsError.Default, t(ReviewsError.Default));
        return ResultServerAction(result, ServerActionName.getReviews);
    }

    const sortingOptions = await mapSortingOptions(reviewsResult.data.sortingOptions);

    return ResultServerAction(ResultSuccess({ ...reviewsResult.data, sortingOptions }), ServerActionName.getReviews);
};
